import React from "react";
import PropTypes from "prop-types";
import { Blockquote } from "@wfp/ui";

import style from "./style.module.scss";

// A wrapper of the Blockquote component form WFP UI Kit
const MessageError = ({ children, icon }) => (
  <div className={style.wrapper}>
    <Blockquote error withIcon={icon}>
      {children}
    </Blockquote>
  </div>
);

// propTypes for the MessageError component
MessageError.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.bool,
};

export default MessageError;
